module.exports = __webpack_public_path__ + "img/dd_03.7de82042.png";